module.exports = __webpack_public_path__ + "img/report1.04eaa8a7.svg";